import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
// import * as random from 'random';

@Injectable({
  providedIn: 'root',
})
export class MatchingGameService {
  // matchingList: any[] = [];

  constructor(private http: HttpClient) {}

  getMatchingList(csvPath?: string) {
    const path = csvPath ? csvPath : 'assets/data/matching-game.json';
    return this.http.get<any>(path).pipe(
      map((res) => {
        // do {
        //   const rand = this.getRandom(res.data.length);
        //   const item = res.data[rand];
        //   if (this.matchingList.findIndex((x) => x.id === item.id) === -1) {
        //     this.matchingList.push(item);
        //   }
        // } while (this.matchingList.length < 6);

        // return this.matchingList;
        return res;
      }),
    );
  }

  // getRandom(x) {
  //   return random.int(0, x - 1);
  //   // return Math.floor(Math.random() * x);
  // }
}
